import React from 'react';

export const RuleEditorContext = React.createContext(null);
